import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import ITOProducts from './pages/Products/ITO/ITO';
import ITOPETProducts from './pages/Products/ITOPET/ITOPET';
import MolybdenumProducts from './pages/Products/Molybdenum/Molybdenum';
import FTOProducts from './pages/Products/FTO/FTO';
import AuAltinProducts from './pages/Products/AuAltin/AuAltin';
import GumusKapliLiflerProducts from './pages/Products/GumusKapliLifler/GumusKapliLifler';
import IsiticiliPencereProducts from './pages/Products/IsiticiliPencere/IsiticiliPencere';
import MiknatisSactirmaKaynaklariProducts from './pages/Products/MiknatisSactirmaKaynaklari/MiknatisSactirmaKaynaklari';
import VakumSistemleriProducts from './pages/Products/VakumSistemleri/VakumSistemleri';
import Projeler from './pages/Products/Projeler/Projeler';
import Referanslar from './pages/Products/Referanslar/Referanslar';
import MalzemeTestVeAnalizleri from './pages/Products/MalzemeTestVeAnalizleri/MalzemeTestVeAnalizleri';
import YuzeyKaplamalar from './pages/Products/YuzeyKaplamalar/YuzeyKaplamalar';
import Danismanlik from './pages/Products/Danismanlik/Danismanlik';
import Egitim from './pages/Products/Egitim/Egitim';
import Contact from './pages/Contact/Contact';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/hakkimizda" element={<About />} />
      
      {/* Product Routes */}
      <Route path="/indium-kalay-oksit-ito-kaplamalar" element={<ITOProducts />} />
      <Route path="/indium-kalay-oksit-ito-pet-kaplamalar" element={<ITOPETProducts />} />
      <Route path="/molibdenyum-kaplamalar" element={<MolybdenumProducts />} />
      <Route path="/flor-kalay-oksit-fto-kaplamalar" element={<FTOProducts />} />
      <Route path="/altin-kaplamalar" element={<AuAltinProducts />} />
      <Route path="/gumus-kapli-lifler" element={<GumusKapliLiflerProducts />} />
      <Route path="/isiticili-pencere" element={<IsiticiliPencereProducts />} />
      <Route path="/miknatis-sactirma-kaynaklari" element={<MiknatisSactirmaKaynaklariProducts />} />
      <Route path="/vakum-sistemleri" element={<VakumSistemleriProducts />} />
      
      {/* Services Routes */}
      <Route path="/malzeme-test-ve-analizleri" element={<MalzemeTestVeAnalizleri />} />
      <Route path="/yuzey-kaplamalar" element={<YuzeyKaplamalar />} />
      <Route path="/danismanlik" element={<Danismanlik />} />
      <Route path="/egitim" element={<Egitim />} />
      
      <Route path="/projeler" element={<Projeler />} />
      <Route path="/referanslar" element={<Referanslar />} />
      <Route path="/iletisim" element={<Contact />} />
    </Routes>
  );
};

export default AppRoutes;